module.exports = __webpack_public_path__ + "img/putin.251464ca.jpg";